import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './Button.module.scss';
import Cost from '../widgets/cost/Cost';
import LoginBack from '@/assets/icons/back.svg?react';
export default function Button({
  active = false,
  width,
  height,
  style,
  children,
  onClick,
  className,
  type,
  onChange,
  id = 'file',
  accept,
  size,
  icon,
  styleType = 'primary',
  round = false,
  cost = 0,
  ...props
}) {
  const { t } = useTranslation('aigc');
  const fileInputRef = useRef(null);
  const costLeftMap = {
    middle: 8,
    small: 2,
    large: 12,
  };
  if (type === 'back') {
    return (
      <div className={`${styles.backButton} ${className}`} onClick={onClick}>
        <LoginBack />
      </div>
    );
  } else if (type === 'text-back') {
    return (
      <button
        className={`${styles.textBackButton} ${className}`}
        onClick={onClick}
      >
        <LoginBack />
        {t('aigc:common.back', '返回')}
      </button>
    );
  } else if (type === 'link') {
    return (
      <button
        className={`${styles.btn} ${styles.linkButton} ${className}`}
        onClick={onClick}
      >
        {children}
      </button>
    );
  } else if (type === 'input') {
    return (
      <button
        onClick={() => {
          // 点击按钮时重置文件输入值, 否则无法选择相同文件
          if (fileInputRef.current) {
            fileInputRef.current.value = '';
          }
        }}
      >
        <label
          data-active={active}
          htmlFor={id}
          data-round={round}
          data-size={size}
          data-style={styleType}
          className={`${styles.btn} ${className}`}
          style={{ width, height, lineHeight: height, ...style }}
          {...props}
        >
          {typeof icon === 'function' ? icon() : <img src={icon}></img>}
          {children}
          {cost > 0 ? (
            <Cost
              black={type !== 'primary'}
              cost={cost}
              left={costLeftMap[size]}
            ></Cost>
          ) : null}
        </label>
        <input
          ref={fileInputRef}
          onChange={(e) => {
            // let files =
            //   e.target.files.length > 0 ? Array.from(e.target.files) : [];
            //   console.log(  e.target.files)
            //   console.log( files)
            onChange(e.target.files);
          }}
          type="file"
          id={id}
          style={{ width: 0, height: 0, zIndex: -1, display: 'none' }}
          accept={accept}
        ></input>
      </button>
    );
  } else {
    return (
      <button
        data-active={active}
        data-style={styleType}
        data-size={size}
        data-round={round}
        className={`${styles.btn} ${className}`}
        style={{ width, height, ...style }}
        onClick={onClick}
        {...props}
      >
        {icon ? (
          typeof icon === 'function' ? (
            icon()
          ) : (
            <img src={icon}></img>
          )
        ) : null}
        {icon ? <span>{children}</span> : children}
        {cost > 0 ? <Cost cost={cost} left={costLeftMap[size]}></Cost> : null}
      </button>
    );
  }
}
